import { Link } from "react-router-dom";
import { Shield, Phone, ArrowLeft } from "lucide-react";
import SiteFooter from "@/components/SiteFooter";
import { BUSINESS } from "@/config/business";

export default function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-[#f4f1e9]">
      <header className="sticky top-0 z-50 border-b border-[#e2ddcf] bg-[#f4f1e9]/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
          <Link
            to="/"
            data-testid="legal-logo-link"
            className="flex items-center gap-2.5"
          >
            <Shield className="h-7 w-7 text-[#223f2e]" strokeWidth={2} />
            <span className="font-display text-[22px] font-semibold tracking-tight text-[#223f2e]">
              {BUSINESS.brandName}
            </span>
          </Link>
          <div className="flex items-center gap-5 sm:gap-8">
            <a
              href={BUSINESS.phoneHref}
              className="hidden items-center gap-2 text-[15px] font-semibold text-[#223f2e] transition-opacity hover:opacity-70 sm:flex"
            >
              <Phone className="h-4 w-4" strokeWidth={2.2} />
              {BUSINESS.phoneDisplay}
            </a>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#bf9a4d] px-6 py-3 text-[14px] font-semibold text-[#1c3325] transition-colors duration-300 hover:bg-[#a9853c]"
            >
              Free Assessment
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16 lg:py-20">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-1.5 text-[14px] font-medium text-[#566257] transition-colors hover:text-[#223f2e]"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <h1 className="font-display text-[40px] font-semibold leading-tight text-[#1e3a2a] sm:text-[48px]">
          {title}
        </h1>
        <p className="mt-3 font-mono-label text-[12px] text-[#4f7a5e]">
          Last updated: {BUSINESS.lastUpdated}
        </p>
        <div className="legal mt-10">{children}</div>
      </main>

      <SiteFooter />
    </div>
  );
}
